"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledButton = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var styles = {
  Primary: (0, _styledComponents.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    color: #fff;\n    border: 2px solid var(--color-text-blue);\n    background-color: var(--color-text-blue);\n  "]))),
  Secondary: (0, _styledComponents.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    color: var(--color-text-blue);\n    border: 2px solid var(--color-text-blue);\n    background-color: transparent;\n  "])))
};
var hoverStyles = {
  Primary: (0, _styledComponents.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    color: #fff;\n    background-color: var(--color-rm-secondary-blue);\n  "]))),
  Secondary: (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    color: #fff;\n    border: 2px solid var(--color-rm-secondary-blue);\n    background-color: var(--color-rm-secondary-blue);\n  "])))
};
var ButtonStyles = (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  height: var(--min-tap-target-height);\n  padding: 0 30px;\n  box-sizing: border-box;\n  font-family: var(--font-sans);\n  font-size: var(--font-size-sm);\n  line-height: var(--line-height-sm);\n  letter-spacing: 3px;\n  white-space: nowrap;\n  font-weight: 400;\n  text-decoration: none;\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n  transition: all 150ms cubic-bezier(0.335, 0.015, 0.46, 0.995);\n  cursor: pointer;\n  ", "\n  ", "\n\n  @media (min-width: 992px) {\n    letter-spacing: 3px;\n    &:hover {\n      ", "\n    }\n  }\n"])), function (props) {
  return styles[props.styleType] || styles.Primary;
}, function (_ref) {
  var width = _ref.width;
  return "width: ".concat(width || '100%', ";");
}, function (props) {
  return hoverStyles[props.styleType] || hoverStyles.Primary;
});

var StyledButton = function StyledButton(component) {
  return (0, _styledComponents.default)(component)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    ", "\n  "])), ButtonStyles);
};

exports.StyledButton = StyledButton;
var _default = {
  A: _styledComponents.default.a(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    ", "\n  "])), ButtonStyles),
  Button: _styledComponents.default.button(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    ", "\n  "])), ButtonStyles)
};
exports.default = _default;